export default __webpack_public_path__ + "static/media/Logo_Nexi_Group_Orizz_Bianco.877288a9.png";